import {
  // 单选、多选组合国家筛选器
  COMPOSED_COUNTRY_SELECT as COMPOSED_COUNTRY_SELECT_FILTER,
  // 单选榜单筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  // 多选榜单筛选器
  MULTIPLE_SOURCE_SELECT as MULTIPLE_SOURCE_SELECT_FILTER,
  // 是否显示热度国家筛选器
  HEAT_MAP as HEAT_MAP_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const getInitialFormValue = (isOperate: boolean, filterExtend: any, defaultFormValue: any) => {
  // 没有操作过筛选器，不继承
  if (!isOperate) return defaultFormValue ?? {};

  /** 各个筛选器的继承值 **/
  const composedCountryFilterExtend = filterExtend?.[COMPOSED_COUNTRY_SELECT_FILTER];
  const singleSourceFilterExtend = filterExtend?.[SINGLE_SOURCE_SELECT_FILTER];
  const multipleSourceFilterExtend = filterExtend?.[MULTIPLE_SOURCE_SELECT_FILTER];
  const heatMapFilterExtend = filterExtend?.[HEAT_MAP_SELECT_FILTER];
  /** 各个筛选器的继承值 **/

  /** 各个筛选器的默认值 **/
  const composedCountryDefault = defaultFormValue?.[COMPOSED_COUNTRY_SELECT_FILTER];
  const singleSourceDefault = defaultFormValue?.[SINGLE_SOURCE_SELECT_FILTER];
  const multipleSourceDefault = defaultFormValue?.[MULTIPLE_SOURCE_SELECT_FILTER];
  const heatMapDefault = defaultFormValue?.[HEAT_MAP_SELECT_FILTER];
  /** 各个筛选器的默认值 **/

  /** 各个筛选器的初始值 **/
  const initialComposedCountryType = composedCountryFilterExtend?.value?.type || composedCountryDefault?.value?.type;
  const initialComposedCountryCountries =
    composedCountryFilterExtend?.value?.countries?.length > 0
      ? composedCountryFilterExtend?.value?.countries
      : composedCountryDefault?.value?.countries;
  const initialSingleSource =
    singleSourceFilterExtend?.value?.length > 0 ? singleSourceFilterExtend?.value : singleSourceDefault?.value;
  const initialMultipleSource =
    multipleSourceFilterExtend?.value?.length > 0 ? multipleSourceFilterExtend?.value : multipleSourceDefault?.value;
  const initialHeatMap = heatMapFilterExtend?.value || heatMapDefault?.value;
  /** 各个筛选器的初始值 **/

  return {
    // 单选、多选组合国家筛选器
    [COMPOSED_COUNTRY_SELECT_FILTER]: {
      value: {
        type: initialComposedCountryType,
        countries: initialComposedCountryCountries,
      },
    },
    // 单选榜单筛选器
    [SINGLE_SOURCE_SELECT_FILTER]: {
      value: initialSingleSource,
    },
    // 多选榜单筛选器
    [MULTIPLE_SOURCE_SELECT_FILTER]: {
      value: initialMultipleSource,
    },
    // 是否显示热度国家筛选器
    [HEAT_MAP_SELECT_FILTER]: {
      value: initialHeatMap,
    },
  };
};
